var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import Icon from "@ant-design/icons";
var CustomerSvg = /* @__PURE__ */ __name(function CustomerSvg2() {
  return /* @__PURE__ */ React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, /* @__PURE__ */ React.createElement("path", {
    d: "M30.311 30.222h-1.689v-0.996c0-3.48-0.116-3.787-1.564-4.116-0.8-0.169-1.547-0.298-2.271-0.444-2.956-0.511-5.293-0.916-6.591-3.596-0.684-1.258-1.084-2.422 0.444-4.911 2.693-4.484 2.124-9.147 0.858-11.018-0.676-1.022-2.062-1.631-3.716-1.631s-3.040 0.604-3.707 1.622c-1.436 2.249-1.622 6.898 0.889 11.058 1.333 2.404 1.187 3.556 0.444 4.889-1.284 2.667-3.556 3.067-6.444 3.578-0.724 0.129-1.476 0.262-2.28 0.444-1.467 0.333-1.573 0.64-1.573 4.124v0.996h-1.698v-0.996c0-3.302 0-5.12 2.884-5.778 0.84-0.187 1.644-0.329 2.351-0.444 2.916-0.52 4.356-0.849 5.227-2.667v-0.044c0.4-0.733 0.693-1.262-0.413-3.271-2.84-4.756-2.573-10.053-0.796-12.809 0.978-1.502 2.893-2.391 5.116-2.391s4.138 0.889 5.124 2.382c1.778 2.604 2.076 8-0.818 12.849-1.151 1.876-0.889 2.391-0.4 3.244v0.040c0.889 1.831 2.364 2.164 5.369 2.667 0.707 0.12 1.502 0.258 2.342 0.444 2.893 0.653 2.893 2.467 2.893 5.778v0.996z"
  }));
}, "CustomerSvg");
var CustomerIcon = /* @__PURE__ */ __name(function CustomerIcon2(props) {
  return /* @__PURE__ */ React.createElement(Icon, _extends({
    component: CustomerSvg
  }, props));
}, "CustomerIcon");
export {
  CustomerIcon
};
